module.exports = __webpack_public_path__ + "img/image142.9cbd656f.jpg";